export default "<p>administration works!</p>\n"